var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspiraLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 293.75 74.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c6495d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.59,0V4.62a22.88,22.88,0,1,0-13.73,41.17,22.69,22.69,0,0,0,13.73-4.61v4.61h9.16V0ZM270.86,36.64A13.74,13.74,0,1,1,284.59,22.9a13.74,13.74,0,0,1-13.73,13.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178,0a22.76,22.76,0,0,0-13.73,4.61V0h-9.16V74.15h9.16v-33A22.88,22.88,0,1,0,178,0m0,36.63A13.74,13.74,0,1,1,191.7,22.9,13.74,13.74,0,0,1,178,36.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.22,
    y: 0.01,
    width: 9.16,
    height: 45.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 207.39,
    y: 0.01,
    width: 9.16,
    height: 45.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.45,18.28A18.24,18.24,0,0,0,88.08,2.46V0H78.92V45.79h9.16V18.27a9.11,9.11,0,1,1,18.21,0V45.79h9.16V18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.35,0a18.27,18.27,0,0,0-18.26,18.26V45.79h9.16V18.26h0a9.09,9.09,0,0,1,9.1-9.1h.07V0h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.91,8.59,139.64,13c-1.31-2.66-2.92-4-4.85-4a3.39,3.39,0,0,0-2.36.91,3.06,3.06,0,0,0-1,2.34c0,1.66,1.92,3.3,5.78,4.93q7.95,3.43,10.71,6.32a10.79,10.79,0,0,1,2.76,7.78,13.6,13.6,0,0,1-4.63,10.49,15.7,15.7,0,0,1-10.84,4q-10.91,0-15.43-10.62l8.53-4a19.16,19.16,0,0,0,2.72,4,6.21,6.21,0,0,0,4.36,1.69q5.06,0,5.06-4.63,0-2.67-3.91-5l-3-1.47c-1-.47-2-1-3.07-1.46A19,19,0,0,1,124.34,20a10.53,10.53,0,0,1-2.26-7,12.38,12.38,0,0,1,3.86-9.34A13.58,13.58,0,0,1,135.55,0q8.31,0,12.36,8.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.89,0A22.89,22.89,0,1,0,45.78,22.9,22.89,22.89,0,0,0,22.89,0m0,36.63A13.74,13.74,0,1,1,36.63,22.9,13.74,13.74,0,0,1,22.89,36.64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspiraLogoWhite);
export default __webpack_public_path__ + "static/media/inspira_logo_white.d022df36f73d75a1d0c2aba1ad6c7a3c.svg";
export { ForwardRef as ReactComponent };